import { ControlFacet } from '../models/controls/ControlFacet';

/**
 * Hook to determine whether or not an item is in a read-only state
 * for a specific item type.
 * @public
 */
export const itemIsReadOnlyControl: ControlFacet<{
  itemKey: string | undefined;
}, {
    isReadOnly: boolean;
  }> = new ControlFacet('itemIsReadOnlyControl');
